import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import DirectLink from 'components/Course/Shared/DirectLink';
import Email from 'components/Course/Shared/Email';
import Button from 'uikit/Button';
import Modal from 'uikit/Modal';
import Tabs from 'uikit/Tabs';

import ExpertLink from './ExpertLink';
import Code from './Code';
import GAR from './GAR';
import styles from './CourseShare.module.scss';
import SharePublic from './SharePublic';
import Social from './Social';

const cx = classNames.bind(styles);

const CourseShare = ({
  canvasRef,
  className,
  course,
  handleModalClose,
  handleModalOpen,
  isDisplayed,
  isExpertLinkDisplayed,
  isGAR,
  isModalOpen,
  t,
}) => (
  <>
    <Button
      className={cx('share-button', className)}
      data-testid="open-share-modal-button"
      icon="link"
      intent={
        course.questions.length ||
        course.chapters.some((chapter) => chapter.questions.length)
          ? 'primary'
          : 'default'
      }
      onClick={handleModalOpen}
    >
      {t('Course/Teacher/Cover/CourseShare/share-course')}
    </Button>
    <Modal isOpen={isModalOpen} onExit={handleModalClose}>
      <div className={cx('modal')}>
        <Button
          aria-label={t('Course/Teacher/Cover/CourseShare/aria-close')}
          className={cx('close')}
          icon="times"
          onClick={handleModalClose}
        />
        <h1 className={cx('title')}>
          {t('Course/Teacher/Cover/CourseShare/title')}
        </h1>
        <Tabs className={cx('tabs')}>
          {isGAR && (
            <Tabs.Tab
              label={t('Course/Teacher/Cover/CourseShare/share-classes')}
            >
              <GAR course={course} handleModalClose={handleModalClose} />
            </Tabs.Tab>
          )}
          {/* TODO REMOVE AFTER GAR QC */}
          {/* {!isGAR && ( */}
          <Tabs.Tab label={t('Course/Teacher/Cover/CourseShare/share-student')}>
            {course.isExam && course.examStartTime === course.examStopTime && (
              <p className={cx('warning')}>
                {t('Course/Teacher/Cover/CourseShare/warning-settings')}
              </p>
            )}
            <DirectLink course={course} />
            <Code className={cx('code')} course={course} />
            {isExpertLinkDisplayed && <ExpertLink course={course} />}
            {!course.moodle.isMoodle && (
              <Email className={cx('email')} course={course} />
            )}
            {isDisplayed && <canvas className={cx('qrcode')} ref={canvasRef} />}
            <Social className={cx('social')} course={course} />
          </Tabs.Tab>
          {/* )} */}
          {/* TODO REMOVE AFTER GAR QC */}
          {/* {!isGAR && ( */}
          <Tabs.Tab label={t('Course/Teacher/Cover/CourseShare/share-public')}>
            <SharePublic course={course} handleModalClose={handleModalClose} />
          </Tabs.Tab>
          {/* )} */}
        </Tabs>
      </div>
    </Modal>
  </>
);

CourseShare.propTypes = {
  canvasRef: PropTypes.func.isRequired,
  className: PropTypes.string,
  course: PropTypes.object.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  isExpertLinkDisplayed: PropTypes.bool.isRequired,
  isGAR: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

CourseShare.defaultProps = {
  className: undefined,
};

export default CourseShare;
